import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface ThumbnailImage {
  url: string;
}
@Component({
  selector: 'app-medicine-image-preview',
  templateUrl: './medicine-image-preview.component.html',
  styleUrls: ['./medicine-image-preview.component.scss'],
})
export class MedicineImagePreviewComponent implements OnInit {
  currentCarouselIndex = 0;
  maxHeight:string = '500px';
  maxWidth:string = '700px';
  maxImageWidth:string = '600px'
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { images: ThumbnailImage[]; startIndex?: number; maxHeight?: string; maxWidth?: string }
  ) {
    this.currentCarouselIndex = data.startIndex ?? 0;
    this.maxHeight = data.maxHeight ?? '500px';
    this.maxWidth = data.maxWidth ?? '700px'
    this.maxImageWidth = this.adjustDimension(data.maxWidth ?? '700px'); 
  }

  private adjustDimension(value: string): string {
    if (value.endsWith('vh')) {
      const num = parseFloat(value);
      return `${num - 10}vh`;
    }
    if (value.endsWith('vw')) {
      const num = parseFloat(value);
      return `${num - 10}vw`;
    }
    return value;
  }

  ngOnInit(): void {}

  nextSlide() {
    this.currentCarouselIndex++;
  }

  prevSlide() {
    this.currentCarouselIndex--;
  }
}
